















































































































































































































































































































































import DragUpload from '@/components/util/DragUpload.vue';
import PropertyPicker from '@/components/system/PropertyPicker.vue';
import OrderAssetListComponent from '@/components/orders/OrderAssetListComponent.vue';
import WorkerPicker from '@/components/workers/WorkerPicker.vue';
import DetailLayout from '@/components/system/DetailsLayout.vue';
import TradePicker from '@/components/system/TradePicker.vue';
import FloorPicker from '@/components/system/FloorPicker.vue';
import Location2Picker from '@/components/system/Location2Picker.vue';
import ContactPicker from '@/components/system/ContactPicker.vue';
import CampusPicker from '@/components/system/CampusPicker.vue';
import ExtendedDataPicker from '@/components/system/ExtendedDataPicker.vue';
import ScrollIntoView from '@/services/ScrollIntoView';

import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  SystemApi,
  ValueListItem,
  WorkordersApi,
  UsersApi,
  Workorder,
  User as PmoUser,
  ValidationProblemDetails,
  PerformoSettings,
  Property,
  Asset,
  AssetsApi,
  GetAssetRequest,
  JobType,
  Contact,
  Building,
  FieldMetadata
} from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {
    DragUpload,
    PropertyPicker,
    OrderAssetListComponent,
    WorkerPicker,
    DetailLayout,
    TradePicker,
    FloorPicker,
    Location2Picker,
    ContactPicker,
    ExtendedDataPicker,
    CampusPicker
  },
  computed: mapGetters({
    settings: 'settings',
    currentProperty: 'currentProperty',
    assetsApi: 'assetsApi',
    wkoApi: 'ordersApi'
  })
})
export default class Create extends Vue {
  private settings!: PerformoSettings;
  private currentProperty!: Property;

  private sys = new SystemApi(this.$store.getters.getApiConfiguration);
  private usersApi = new UsersApi(this.$store.getters.getApiConfiguration);
  private assetsApi!: AssetsApi;
  private wkoApi!: WorkordersApi;

  private query!: GetAssetRequest;
  private selectedContact: Contact = {};
  private submitDisabled = false;

  // used to pass picked contact location data into the location pickers.
  // these values are "sticky" in the location pickers,
  // so that they persist across the triggered api calls and loading.
  private intendedLocationData: Contact = {};

  priorities: ValueListItem[] = [];
  selectedAssets: Asset[] = [];
  customFields: FieldMetadata[] = [];

  hasPhoto = false;
  currentPerformoUserAndContact: PmoUser = { contact: {} };
  createdOrderId? = '';

  get currentUserName(): string {
    return this.$store.getters.userDisplayName;
  }
  get currentPropertyId(): string {
    return this.$store.getters.currentPropertyId;
  }

  private createOrderWatcher = false;
  // this lets the undefined order! refs become reactive
  // https://class-component.vuejs.org/guide/class-component.html#data
  private order: Workorder = {
    propertyId: this.currentPropertyId,
    assignTo: undefined,
    campus: undefined,
    building: undefined,
    floor: undefined,
    suite: undefined,
    trade: undefined,
    jobType: undefined,
    extendedData: undefined
  };
  private validationProblems: ValidationProblemDetails = {};

  private async mounted() {
    this.currentPerformoUserAndContact = await this.usersApi.getMyProfile();
    const wkoApi = new WorkordersApi(this.$store.getters.getApiConfiguration);
    this.customFields = await wkoApi.getCustomFields();
    if (this.settings.enableCampuses) {
      this.intendedLocationData.campus =
        this.currentPerformoUserAndContact?.contact?.campus;
    }
    if (
      this.currentPerformoUserAndContact &&
      this.currentPerformoUserAndContact.contact &&
      this.currentPerformoUserAndContact.contact.propertyId ===
        this.currentPropertyId
    ) {
      this.intendedLocationData.location1 =
        this.currentPerformoUserAndContact.contact.location1;
      this.intendedLocationData.location2 =
        this.currentPerformoUserAndContact.contact.location2;
      this.intendedLocationData.floor =
        this.currentPerformoUserAndContact.contact.floor;
    }

    // if creating an order from the asset detail view, add asset to pending Order
    if (Object.keys(this.$route.query).length > 0) {
      this.query = {
        assetId: parseInt(this.$route.query['assetId'] as string)
      };

      if (this.query.assetId) {
        const pickedAsset = await this.assetsApi.getAsset(this.query);
        this.selectedAssets.push(pickedAsset);
      }
    }

    // if defaultSelfAssign setting is on, auto-fill the assign to with the current worker
    if (this.settings.defaultSelfAssign) {
      this.order.assignTo = this.currentPerformoUserAndContact.workerVendor;
    }

    // run the initial load
    await this.loadOrderCreate();
  }

  @Watch('order.propertyId', { deep: true })
  private async loadOrderCreate() {
    // refresh things if/when property is changed.
    if (this.order.propertyId) {
      this.priorities = await this.sys.getValueListItems({
        propertyId: this.order.propertyId,
        name: 'Priority'
      });
    }
  }

  private photoSuccessHandler() {
    if (this.createdOrderId) {
      this.$router.push({
        name: 'work-order-detail',
        params: { id: this.createdOrderId.toString() }
      });
    }
  }

  private async successHandler(order: Workorder) {
    // update with our newly minted work order
    this.createdOrderId = order.workorderId?.toString();

    // add any queued photos
    // if a file is attached, we have to use the upload er to do the upload as well as the form submission
    // otherwise we hit the api directly.
    if (this.hasPhoto) {
      // await nextTick, since we need the prop passed dragupload to update before we process the queue
      await this.$nextTick();

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.$refs.dragUpload as any).processUploadQueue();
    }

    // add assets to order before routing to detail view
    if (order && order.workorderId) {
      this.selectedAssets.forEach(async (asset) => {
        if (asset.assetId) {
          await this.wkoApi.addAssetToOrder({
            workorderAssetCreateCommand: {
              workorderId: order.workorderId,
              assetId: asset.assetId
            }
          });
        }
      });

      // if we have a photo, the success handler will redirect, if not we redirect here.
      if (!this.hasPhoto) {
        this.$router.push({
          name: 'work-order-detail',
          params: { id: order.workorderId }
        });
      }
    }
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    if (error instanceof Response) {
      error = await error.json();
    }

    this.validationProblems = error;

    // scroll the error div into view on a delay
    setTimeout(() => {
      ScrollIntoView('error-display');
    }, 100);

    // since there was an error, re-enable the submit button to allow the user to try again
    this.submitDisabled = false;
  }

  private fileAddedHandler() {
    this.hasPhoto = true;
  }

  private jobTypePickedHandler(pickedJobType: JobType) {
    this.order.trade = pickedJobType.trade;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private extendedDataPickedHandler(newExtendedData: { [key: string]: any }) {
    this.order.extendedData = newExtendedData;
  }

  private buildingPickedHandler(pickedBuilding: Building) {
    if (this.settings.enableCampuses) {
      this.order.campus = pickedBuilding.campusName;

      // updating order.campus may trigger the building picker to load new building values
      // we set the intended location data here to persist the building value
      this.intendedLocationData.location1 = pickedBuilding.buildingCode;
    }
  }

  private async createRequest() {
    this.submitDisabled = true;
    const wkoApi = new WorkordersApi(this.$store.getters.getApiConfiguration);
    wkoApi
      .createWorkOrder({ workorderCreateCommand: this.order })
      .then(this.successHandler, this.errorHandler)
      .finally(() => {
        // empty
      });
  }

  private updateSelectedAssets(assets: Asset[]) {
    assets.forEach((asset) => {
      // filter out duplicates
      const found = this.selectedAssets.some(
        (a) => a.assetId === asset.assetId
      );
      if (!found) {
        this.selectedAssets.push(asset);
      }
    });
  }

  private updateSelectedContact(contact: Contact) {
    if (contact) {
      this.selectedContact = contact;

      // set this because we want the order location details to match the contact's
      this.intendedLocationData = contact;
    } else {
      this.selectedContact = {};
    }
  }
}
